import React from 'react';
import { toast } from 'react-toastify';
import Toast from '../components/Toast';

// const ToastUndo = ({ infos }) => {
//     function handleClick(){
//       console.log(infos)
//     }
  
//     return (
//         <div>
//             <div style={{ display: "flex", alignItems: "baseline" }}>
//                 <div><img src={`${process.env.PUBLIC_URL}/images/icon-roubo.png`} /></div>
//                 <div style={{ marginLeft: 10 }}><p style={{ fontWeight:"bold" }} >{infos.tipo}</p></div>
//             </div>
//             <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
//                 <p>{`${infos.usuario.nome} reportou um novo alerta!`}</p>
//                 <button onClick={handleClick}>Localização</button>
//             </div>
//         </div>
//     );


// }

export const notification = (infos, type) => {
    switch(type){
        case "success":
            return toast.success(infos, {
                position: toast.POSITION.TOP_RIGHT
            });
        case "warn":
            return toast.warn(infos, {
                position: toast.POSITION.TOP_RIGHT
            });
        case "reset-password":
            return toast.success(infos, {
                position: toast.POSITION.TOP_RIGHT,
            })
        default:
            return toast.error(<Toast infos={infos} />, {
                position: toast.POSITION.TOP_RIGHT,
                closeOnClick: false,
                autoClose: 20000
            });
    }
};


// WEBPACK FOOTER //
// ./src/util/toast.js